import { useState } from 'react';
import Header from '../../../../customs/Header';
import AdminRoleContent from './AdminRoleContent';
import SettingsModal from '../Modal/settingsCustomModal';
import CreateRoleContent from './CreateRole';

export const AdminRole = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);
  
  return (
    <section>
      <Header props={
        { 
          firstName: 'All', 
          secondName: 'Admin Role', 
          buttonText: 'Create Role'
        }}
        handleOpen={handleOpenCreateModal}
      />

      <AdminRoleContent />

      <SettingsModal 
        open={openCreateModal}
        cancel={handleCloseCreateModal}
        maxWidth='480px'
        header='Create Role'
        showrightIcon={false}
        content={<CreateRoleContent handleClose={handleCloseCreateModal}/>}      
      />
    </section>
  )
}

export default AdminRole;
